import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import moment from 'moment';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-plan-aliases',
    templateUrl: './plan-aliases.component.html',
    styleUrls: [
        './plan-aliases.component.scss',
    ],
    standalone: false
})
export class PlanAliasesComponent implements OnInit {
  @Input() carrierPlanId: string;
  aliases: [];
  selectedAlias: any;
  first: number = 0;
  last: number;
  rows:number = 10;
  totalRecords: number;

  tableConfig = {
    columns: {
      plan_name: {
        title: 'Alias name',
      },
      organization: {
        title: 'Organization',
      },
      matched_at: {
        title: 'Matched on',
      }
    },
    actions: {
      add: false,
      edit: false,
      delete: false
    }
  };

  keys = Object.keys(this.tableConfig.columns);
  placeholders = {
    plan_name: 'Alias name',
    organization: 'Organization',
    matched_at: 'Matched on',
  };

  constructor(protected http: HttpClient) { }

  ngOnInit() {
    const url = `/carrier_plans/${this.carrierPlanId}/aliases`
    this.http.get(`${environment.apiurl}/${url}`, { observe: 'response' }).subscribe((response: any) => {
      this.totalRecords = response.body.meta['x-total-count'];
      this.aliases = this.formatAliases(response.body.data);
    });
  }

  formatAliases = (aliases) => {
    aliases.forEach(alias => {
      alias['matched_at'] = alias['matched_at'] ? moment(alias['matched_at']).format('LL') : alias['matched_at'];
    });
    return aliases;
  }
}
